/** Formatting helpers. Money is integer Iraqi dinars; digits are Latin for readability in finance screens. */
const numberFmt = new Intl.NumberFormat('en-US');
const dateFmt = new Intl.DateTimeFormat('ar-IQ-u-nu-latn', { timeZone: 'Asia/Baghdad', year: 'numeric', month: '2-digit', day: '2-digit' });
const dateTimeFmt = new Intl.DateTimeFormat('ar-IQ-u-nu-latn', {
  timeZone: 'Asia/Baghdad',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});
const timeFmt = new Intl.DateTimeFormat('ar-IQ-u-nu-latn', { timeZone: 'Asia/Baghdad', hour: '2-digit', minute: '2-digit' });
const ymdFmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Baghdad', year: 'numeric', month: '2-digit', day: '2-digit' });

export const CURRENCY = 'د.ع';

export const formatNumber = (n: number | null | undefined) => (n === null || n === undefined ? '—' : numberFmt.format(n));
export const formatMoney = (n: number | null | undefined) => (n === null || n === undefined ? '—' : `${numberFmt.format(n)} ${CURRENCY}`);
export const formatDate = (d: string | Date | null | undefined) => (d ? dateFmt.format(new Date(d)) : '—');
export const formatDateTime = (d: string | Date | null | undefined) => (d ? dateTimeFmt.format(new Date(d)) : '—');
export const formatTime = (d: string | Date | null | undefined) => (d ? timeFmt.format(new Date(d)) : '—');

/** YYYY-MM-DD of a date in the business timezone (what the API expects). */
export const toYmd = (d: Date = new Date()) => ymdFmt.format(d);
export const addDaysYmd = (days: number, from = new Date()) => toYmd(new Date(from.getTime() + days * 86_400_000));

export function formatMinutes(total: number) {
  const h = Math.floor(total / 60);
  const m = Math.round(total % 60);
  if (h === 0) return `${m} دقيقة`;
  return m ? `${h} س ${m} د` : `${h} ساعة`;
}

export function formatDistance(meters: number) {
  return meters >= 1000 ? `${(meters / 1000).toFixed(1)} كم` : `${Math.round(meters)} م`;
}

/** "2 صندوق + 3 كرتون" from a base quantity and the product units. */
export function describeQuantity(units: { name: string; factor: number }[], base: number) {
  const parts: string[] = [];
  let rest = base;
  for (const u of [...units].sort((a, b) => b.factor - a.factor)) {
    const n = Math.floor(rest / u.factor);
    if (n > 0) {
      parts.push(`${numberFmt.format(n)} ${u.name}`);
      rest -= n * u.factor;
    }
  }
  return parts.length ? parts.join(' + ') : '0';
}

/** "1 س 5 د" / "45 ث" from seconds. */
export function formatDuration(seconds: number | null | undefined) {
  if (seconds === null || seconds === undefined) return '—';
  if (seconds < 60) return `${Math.max(0, Math.round(seconds))} ث`;
  return formatMinutes(Math.round(seconds / 60));
}
